import React, { useEffect, useState } from "react";
import { fetchMovies } from "../../functions/api";
import FilmCard from "../cards/FilmCard";
import az_flag from "../../assets/img/Azerbaijan.png";
import tr_flag from "../../assets/img/Turkey.png";
import ru_flag from "../../assets/img/Russia.png";
import uk_flag from "../../assets/img/UK.png";
import Loader from "../Loader";
// import { useTranslation } from "react-i18next";

const SuIdmanSarayiToday = () => {
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);
  // const { t } = useTranslation();


  useEffect(() => {
    const getMovies = async () => {
      try {
        const data = await fetchMovies();
        const today = new Date().toISOString().split("T")[0];

        // Фильтруем фильмы по дате и branch
        const filteredMovies = data.filter(
          (movie) =>
            new Date(movie.date).toISOString().split("T")[0] === today &&
            movie.branch === "Su İdman Sarayı"
        );

        setMovies(filteredMovies);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Ошибка при загрузке фильмов:", error);
      }
    };

    getMovies();
  }, []);

  const getFlags = (movie) => {
    const flags = [];
    if (movie?.az_lang) flags.push(az_flag);
    if (movie?.tr_lang) flags.push(tr_flag);
    if (movie?.ru_lang) flags.push(ru_flag);
    if (movie?.en_lang) flags.push(uk_flag);
    return flags;
  };

  if (loading) {
    return <Loader />;
  }

  if (movies.length === 0) {
    return <p className="text-white">Film yoxdur</p>;
  }

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4">
      {movies.map((movie) => (
        <FilmCard
          key={movie.id}
          variant="compact"
          img={movie.poster}
          color="purple"
          title={movie.title}
          time={movie.time}
          date={formatDate(movie.date)}
          centers={movie.branch}
          flags={getFlags(movie)} // Исправлено на `flags` вместо `flag`
          pufik_lang={movie.pufik_lang}
          iticket_link={movie.iticket_link}

        />
      ))}
    </div>
  );
};

export default SuIdmanSarayiToday;
